/**
 * Datos "efectivos" de un edificio prospectado: la base catastral
 * (`prospeccion_puntos`, solo-lectura para la UI) más las correcciones de campo
 * que el comercial guarda en `prospectos_crm.datosCorregidos`. La fuente
 * catastral nunca se pisa: una corrección en null significa "vale el original".
 */
export function datosEdificio(punto, crm) {
  const d = (crm && crm.datosCorregidos) || {};
  const num = (v) => (v == null || v === "" ? null : Number(v));
  const dir = d.direccion || null;
  const uni = num(d.nUnidades);
  const anio = num(d.anioConstruccion);
  return {
    direccion: dir || punto?.direccion || crm?.direccion || null,
    nUnidades: uni != null ? uni : (punto?.nUnidades ?? null),
    anioConstruccion: anio != null ? anio : (punto?.anioConstruccion ?? null),
    nota: d.nota || null,
    corregido: { direccion: !!dir, nUnidades: uni != null, anioConstruccion: anio != null },
    hayCorrecciones: !!(dir || uni != null || anio != null),
  };
}
